interface CustomWindow extends Window {
  wogaaCustom?: {
    startTransactionalService: (trackerTrackingId: string) => void;
    completeTransactionalService: (trackerTrackingId: string) => void;
  };
}

export const customWindow = window as CustomWindow;

